import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    bpName: "",
    columns: [],
    docCount: 0,
    docData: [],
    docIds: [],
    formType: void 0,
    formTypeId: 0,
    fullQuery: "",
    offset: 0,
    step: "",
    type: void 0,
    workflow: ""
  }
};
const ActiveDocumentListSlice = createSlice({
  name: "activeDocumentList",
  initialState,
  reducers: {
    loadADDocuments: (state, action) => {
      state.value = {
        bpName: action.payload.bpName,
        columns: action.payload.columns,
        docCount: action.payload.docCount,
        docData: action.payload.docData,
        docIds: action.payload.docIds,
        formType: action.payload.formType,
        formTypeId: action.payload.formTypeId,
        fullQuery: action.payload.fullQuery,
        offset: action.payload.offset,
        step: action.payload.step,
        type: action.payload.type,
        workflow: action.payload.workflow
      };
    }
  }
});
export const { loadADDocuments } = ActiveDocumentListSlice.actions;
export default ActiveDocumentListSlice.reducer;
